import { render } from "./Integer.vue?vue&type=template&id=20bcf8cc&lang=pug"
import script from "./Integer.vue?vue&type=script&lang=ts"
export * from "./Integer.vue?vue&type=script&lang=ts"
script.render = render

export default script